import jwt_decode from 'jwt-decode';
import { Session } from 'next-auth';
import { ApiConfig, configParameters } from './types';
import { logError } from '../Analytics';
import { getClientConfig } from '../Config/ClientConfig';

export const validateSessionToken = (session: Session | null) => {
  if (!session?.user || !session.user.institution || !session.user.access_token) {
    throw new Error('session not valid');
  }

  const {
    user: { access_token },
  } = session;

  return access_token;
};

export const braavosFetch = async (path: string, fetchOptions?: RequestInit) => {
  let response;
  try {
    const { braavosDomain } = await getClientConfig();
    const url = `${braavosDomain}/${path}`;
    response = await fetch(url, fetchOptions);
    if (response.status !== 200) {
      throw new Error(`Response status not 200`);
    }
    return response;
  } catch (error: any) {
    let message = 'Fetch to braavos failed';
    if (error.message) {
      message += `: ${error.message}`;
    }
    console.error(message);
    logError(message, { status: response?.status, body: response?.body }).catch((error) =>
      console.error('Failed to log error', error),
    );
    throw error;
  }
};

export const apiConfig = (): ApiConfig => {
  return {
    setConfig: ({ method, contentType, token = '', body = null }): configParameters => {
      return {
        method,
        headers: {
          'Content-Type': contentType,
          Authorization: `Bearer ${token}`,
        },
        body,
      };
    },
  };
};

export function checkIfTokenObjectValid(token: any) {
  if (!token) {
    return false;
  }
  const access_token = token.access_token ? token.access_token : token.user.access_token;
  if (!access_token) {
    return false;
  }
  try {
    const t = jwt_decode<any>(access_token);
    if (!t.exp) {
      return false;
    }
    // @ts-ignore
    if (Number(t?.exp) > Number(Date.now() / 1000)) {
      return true;
    }
  } catch (e) {
    return false;
  }

  return false;
}

export type RequestInit = Parameters<typeof fetch>[1];
